export default {
  isAutocompleteSuggestionsIXPTestEnabled:
    parseInt(
      document.getElementById('navigation-container')?.dataset.numberOfAutocompleteSuggestions,
      10
    ) > 0
};
